@import "../../../../../shared/styles/base";

.container {
  position: relative;
  display: flex;
  align-items: center;

  & + .container {
    margin-top: 0.5rem;
  }

  .label {
    margin-bottom: 0;
    align-items: center;
    display: flex;
    cursor: pointer;
    line-height: 1.25;
  }

  & input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 1.25rem;
    width: 1.25rem;
  }

  .checkbox {
    height: 1.25rem;
    width: 1.25rem;
    border: 1.5px solid $ds-neutral-300;
    border-radius: 0.25rem;
    margin-right: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 1.25rem;
  }

  & input:focus ~ .label .checkbox {
    outline: $focus-outline;
    outline-offset: 1px;
  }

  & input:checked ~ .label .checkbox,
  input:indeterminate ~ .label .checkbox {
    background-color: $ds-violet-500;
    border-color: $ds-violet-500;
    transition: background-color 0.1s ease-in-out, border-color 0.1s;

    @keyframes show-icon {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

    & svg {
      width: 100%;
      color: #fff;
      display: flex;
      opacity: 1;
      animation: show-icon 0.5s ease 1;
    }
  }

  & input:invalid ~ .label .checkbox {
    border-color: $ds-coral-600;
    transition: background-color 0.1s ease-in-out, border-color 0.1s;
  }

  & input:invalid:checked ~ .label .checkbox,
  input:invalid:indeterminate ~ .label .checkbox {
    background-color: $ds-coral-600;
    transition: background-color 0.1s ease-in-out, border-color 0.1s;
  }

  .badge {
    margin-left: 0.5rem;
  }
}

input:disabled ~ .label .checkbox {
  border-color: $ds-neutral-200;
  background-color: $ds-neutral-200;
}
